import cn from 'classnames';

export default function SupportPlanTableHeader() {
  return (
    <>
      <TitleContainer title={'Packages'} />
      <TitleContainer title={'Bronze'} />
      <TitleContainer title={'Silver'} />
      <TitleContainer title={'Gold'} />
    </>
  );
}

function TitleContainer({ title }: { title: string }) {
  return (
    <div
      className={cn(
        `hidden lg:flex col-span-full md:col-span-3 font-medium py-2 text-black uppercase font-terminal justify-start px-8 border-l border-t border-black`
      )}
    >
      {title}
    </div>
  );
}
